import React from "react";
import styled from "styled-components";

const StyledFooterContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  grid-column-gap: 12px;
  margin: 0 auto;
  padding: 25px 0;
  width: 80%;
  div {
    text-align: left;
    padding: 20px 0;
  }
  #footerAddress {
    grid-column: 1 / span 2;
  }
  li,
  address {
    font-family: montserrat;
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
    color: #362f2d;
    padding: 2px 0;
  }
  a,
  a:hover,
  a:focus {
    font-family: montserrat;
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
    color: #362f2d;
    text-decoration: none;
  }
  .footerItemHeader {
    font-family: Lato, sans-serif;
    font-size: 12px;
    letter-spacing: 2px;
  }
`;

const StyledCopyrightContainer = styled.div`
  display: flex;
  background: #282828;
  color: #fff;
  padding: 15px 0;
  .copyrightRow {
    margin: 0 auto;
    width: 80%;
  }
  .copyrightLinks {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    float: left;
    width: 50%;
  }
  .copyrightText {
    font-size: 10px;
    margin-top: 8px;
  }
  @media (max-width: 648px) {
    .copyrightText {
      margin-top: 0px;
      line-height: normal;
    }
  }
  .copyrightFinePrint,
  .copyrightFinePrint:hover,
  .copyrightFinePrint:focus {
    color: #fff;
    text-decoration: none;
  }
  .copyrightMedia {
    float: right;
    margin-bottom: 0;
    list-style: none;
  }
  li {
    margin-left: 10px;
    display: inline-block;
    width: 25px;
    height: 25px;
    border-radius: 25px;
    text-align: right;
  }
  i {
    color: #fffccf;
    border: 1px solid #282828 !important;
    display: inline-block;
    padding: 3px;
    margin-bottom: 5px;
  }
`;

 const NewFooter = ()=> {
    return (
      <div style={{ backgroundColor: "#f5f5f5" }}>
        <StyledFooterContainer>
          <div className="footerGridItem" id="footerAddress">
            <img
              src={require("../../../assets/images/IzendaNewLogoDark.png")}
              alt="logo"
            />
            <br />
            <br />
            <div className="footerItemHeader">CONTACT US</div>
            <address>
              Toll Free : 888-IZENDA (888-493-6321)
              <br />
              Local Atlanta : 678-619-5889
              <br />
              Fax : 678-568-2283
              <br />
            </address>
            <br />
            <address>
              Izenda, Inc.
              <br />
              PO Box 19937
              <br />
              Atlanta, GA 30325
              <br /><br />
              sales@izenda.com
              <br />
            </address>
          </div>
          <div className="footerGridItem">
            <div className="footerItemHeader">PLATFORM</div>
            <ul>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/business-intelligence-platform/"
                >
                  Platform
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/developer/"
                >
                  Technology
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/integration/"
                >
                  Integration
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/dashboards-reports/"
                >
                  Dashboard &amp; Reports
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/ad-hoc-reporting/"
                >
                  Ad Hoc Reporting
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/data-visualizations/"
                >
                  Visualizations
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/administrative-ui/"
                >
                  Administrative UI
                </a>
              </li>
            </ul>
          </div>
          <div className="footerGridItem">
            <div className="footerItemHeader">SOLUTIONS</div>
            <ul>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/solutions/"
                >
                  Solutions
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/solutions/"
                >
                  Embedded
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/solutions/"
                >
                  BI Portal
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/pricing/"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="http://ma.izenda.com/izenda-embedded-analytics-demo-01"
                >
                  Request a Demo
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="http://ma.izenda.com/try-izenda-now-v2"
                >
                  Get a Free Trial
                </a>
              </li>
            </ul>
          </div>
          <div className="footerGridItem">
            <div className="footerItemHeader">COMPANY</div>
            <ul>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/"
                >
                  Why Izenda?
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/newsroom/"
                >
                  Newsroom
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/embedded-bi-and-analytics-scholarship/"
                >
                  Scholarship
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/contact-us/"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div className="footerGridItem">
            <div className="footerItemHeader">RESOURCES</div>
            <ul>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/resources/"
                >
                  Resources
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/white-papers/"
                >
                  White Papers
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/case-studies/"
                >
                  Case Studies
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/7-series-product-videos/"
                >
                  Videos
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/blog/"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/bi-terms/"
                >
                  Glossary
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/docs/"
                >
                  Documentation
                </a>
              </li>
            </ul>
          </div>
        </StyledFooterContainer>

        <StyledCopyrightContainer>
          <div className="copyrightRow">
            <div className="copyrightLinks">
              <p className="copyrightText">
                Copyright 2021 Izenda, Inc. |{" "}
                <a
                  className="copyrightFinePrint"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/terms/"
                >
                  Terms of Service
                </a>{" "}
                |{" "}
                <a
                  className="copyrightFinePrint"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/privacy-notice/"
                >
                  Privacy Policy
                </a>{" "}
                |{" "}
                <a
                  className="copyrightFinePrint"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.izenda.com/izenda-sitemap/"
                >
                  Sitemap
                </a>
              </p>
            </div>
            <ul className="copyrightMedia">
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="http://twitter.com/izenda"
                >
                  <i className="fa fa-twitter"></i>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/company/izenda"
                >
                  <i className="fa fa-linkedin"></i>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.youtube.com/user/IzendaReportsVideos"
                >
                  <i className="fa fa-youtube-play"></i>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="http://feeds.feedburner.com/izendaembeddedbi"
                >
                  <i className="fa fa-rss"></i>
                </a>
              </li>
            </ul>
          </div>
        </StyledCopyrightContainer>
      </div>
    );
}

export default NewFooter



// WEBPACK FOOTER //
// ./src/components/common/Footer/NewFooter.jsx